import { render, staticRenderFns } from "./LogoutCallback.vue?vue&type=template&id=f89b1ce4&"
import script from "./LogoutCallback.js?vue&type=script&lang=js&"
export * from "./LogoutCallback.js?vue&type=script&lang=js&"
import style0 from "./LogoutCallback.vue?vue&type=style&index=0&id=f89b1ce4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports